import React from 'react';
import { Save } from 'lucide-react';

const SaveScreen = () => (
  <div className="p-4 flex items-center justify-center h-full">
    <div className="text-center">
      <Save size={48} className="text-blue-500 mx-auto mb-4" />
      <h2 className="text-xl font-medium">保存画面</h2>
      <p className="text-gray-500 mt-2">ここにはプロジェクト保存機能が表示されます</p>
    </div>
  </div>
);

export default SaveScreen;